import { render } from "./CourseManagement.vue?vue&type=template&id=7d4ffe15&scoped=true"
import script from "./CourseManagement.vue?vue&type=script&lang=js"
export * from "./CourseManagement.vue?vue&type=script&lang=js"

import "./CourseManagement.vue?vue&type=style&index=0&id=7d4ffe15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4ffe15"]])

export default __exports__